module.exports = __webpack_public_path__ + "static/media/no-thumbnail.982bf775.png";